import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { permissionsKeyMap } from 'routes/permissions/permissionKeys';
import DonorCommunicationModal from './modals/DonorCommunicationModal';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import CommunicationModal from './CommunicationModal';
import { useDonorCommunications, useCreateDonorCommunication } from 'hooks/useDonors';
import { useAuthContext } from 'context/authContext';

const DonorCommunications = () => {
  const { id } = useParams();
  const { selectedBranchId } = useAuthContext();
  const [modalShow, setModalShow] = useState(false);

  const { communications, isLoading: loading } = useDonorCommunications(id);
  const { createCommunicationAsync, isCreating: createCommunicationLoading } = useCreateDonorCommunication();

  const columns = [
    {
      accessor: 'ref',
      Header: 'Ref',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        const { id } = rowData.row.original;
        return id;
      }
    },
    {
      accessor: 'date',
      Header: 'Date',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { created_at } = rowData.row.original;
        return dayjs(created_at).format('MMM-DD-YYYY');
      }
    },
    {
      accessor: 'type',
      Header: 'Type',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { communication_type } = rowData.row.original;
        return communication_type;
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'fw-medium py-2'
      },
      Cell: rowData => {
        return (
          <>
            {rowData.row.original.status ? (
              <SoftBadge pill bg={'success'} className="me-2">
                {rowData.row.original.status} <FontAwesomeIcon icon={'check'} />
              </SoftBadge>
            ) : (
              <></>
            )}{' '}
          </>
        );
      }
    },
    {
      accessor: 'title',
      Header: 'Title',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { subject } = rowData.row.original;
        return subject;
      }
    }
    // {
    //   accessor: 'id',
    //   DonationHeader: '',
    //   cellProps: {
    //     className: 'py-2 text-end'
    //   },
    //   disableSortBy: true,

    //   Cell: rowData => {
    //     const { id } = rowData.row;
    //     return (
    //       <TableRowAction
    //         onCLickEdit={() => console.log(id)}
    //         onCLickDelete={() => console.log(id)}
    //       />
    //     );
    //   }
    // }
  ];

  const [showCommunicationForm, setShowCommunicationForm] = useState(false);

  const handleCreateCommunication = async (data) => {
    try {
      await createCommunicationAsync({
        subject: data.subject,
        messsage_content: data.messsage_content,
        donar_id: id,
        branch_id: selectedBranchId
      });
      setShowCommunicationForm(false);
    } catch (error) {
      // Error handled by hook
      console.error(error);
    }
  };

  return (
    <>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={communications || []}
            columns={columns}
            title="Communications"
            showSearchInput
            searchInputPlaceHolder="Search"
            loading={loading}
            addNew
            onClickAddNew={() => setShowCommunicationForm(true)}
            subject={permissionsKeyMap.donor.children.donors}
          />
        </Col>
      </Row>

      {modalShow && (
        <DonorCommunicationModal
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}

      {showCommunicationForm && (
        <CommunicationModal
          show={showCommunicationForm}
          onHide={() => setShowCommunicationForm(false)}
          onSubmit={handleCreateCommunication}
          loading={createCommunicationLoading}
        />
      )}
    </>
  );
};

export default DonorCommunications;
